import { AxiosError } from 'axios';
import { useCallback, useState } from 'react';

import { checkAxiosError } from '@flipster/utils/axios';

import { useThrottleCallback } from './throttle';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export function useSendApi<T extends (...args: any[]) => void | Promise<void>>(
  apiFn: T,
  errorHandler?: (err: AxiosError<unknown>) => void,
) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<unknown>();

  const callFn = useThrottleCallback(async (...args: Parameters<T>) => {
    if (isLoading) return;
    setIsLoading(true);
    setError(undefined);
    try {
      await apiFn(...args);
    } catch (err) {
      setError(err);
      if (checkAxiosError(err)) errorHandler?.(err);
    } finally {
      setIsLoading(false);
    }
  });

  const resetError = useCallback(() => setError(undefined), []);

  return [isLoading, callFn, error, resetError] as const;
}
